<template>
  <div class="errorPage">
    <img src="./images/error.png" />
  </div>
</template>

<script>
	export default {
    name:'errorpage',
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .errorPage
    width 100%
    height 100%
    background #f6af48
    img
      width 100%
      height auto
</style>



// WEBPACK FOOTER //
// src/pages/ErrorPage/ErrorPage.vue